import { sanitizeUrl } from 'shared-widget-components/src/utils/sanitizeUrl';
import usePackageUrl from './usePackageUrl';
import { PackageSlide } from '../../../../models/slides/PackageSlide';

export const usePackageContentClick = ({ packageData }: { packageData: PackageSlide }) => {
  const { createUrl } = usePackageUrl();

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  // @ts-ignore
  const languageCode = window.currentLanguageCode;

  // if not on admin page, navigate to the package page on click
  const onPackageClick = () => {
    if (isAdmin) return;

    const url = createUrl(packageData.productVariantId, packageData.title, languageCode);

    const sanitizedUrl = sanitizeUrl(url);

    window.location.href = sanitizedUrl;
  };
  return { onPackageClick };
};
